import styled from 'styled-components';
import { Breakpoints } from '../../../../../styled/constants';

export const AgencyInfoWrapper = styled.div`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const OwnerAdditionalInfoWrapper = styled.div`
  display: none;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: block;
  }
`;
